import { api } from './client';
import type { ApiResponse } from './types';

export interface EventJourney {
  eventId: string; title: string;
  timing: { phase: string; startsAt: string | null; endsAt: string | null; timezone: string; precision: string };
  viewer: { authenticated: boolean; state: string; ticketCount: number };
  decision: { primaryFacts: Fact[]; supportingFacts: Fact[]; warnings: string[] };
  arrival: { venueName: string | null; address: string | null; city: string | null; state: string | null; isVirtual: boolean };
  /** cardOnly: shown only where the event is a card; on the event page it points at itself. */
  primaryAction: { code: string; label: string; destination: string; requiresAuth: boolean; cardOnly: boolean };
  actionReason: string;
  refresh: { maxIntervalSeconds: number; nextTransitionAt: string | null };
}
interface Fact { code: string; label: string; source: string; confirmedAt: string | null }
export const getEventJourney = (eventId: string) => api.get<ApiResponse<EventJourney>>(`/events/${eventId}/journey`);
